'use strict';
import React from 'react';
import PropTypes from 'prop-types';

function BrandedCover (props) {
  const {className, title, text, link, description, linkName, backgroundImage, logoImage} = props;

  return (
    <div className={'filter-section__bg ' + className} style={{backgroundImage: `url(${backgroundImage})`}}>
      <div className='promo'>
        <div className='title'>{title}</div>
        <div className='action'>
          { logoImage && <img alt={title} src={logoImage} /> }
          <a className='button' onClick={props.onClick} href={link} target='_blank' title={description}>{linkName}</a>
          { text && <div className='text'>{text}</div> }
        </div>
      </div>
    </div>
  );
}

BrandedCover.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  link: PropTypes.string.isRequired,
  backgroundImage: PropTypes.string.isRequired,
  logoImage: PropTypes.string,
  linkName: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func
};

BrandedCover.defaultProps = {
  linkName: 'Узнать цены',
  logoImage: null,
  text: '',
  description: '',
  className: '',
  onClick: () => {}
};

export default BrandedCover;



// WEBPACK FOOTER //
// ./src/ui/Widgets/BrandedCover.jsx